import VueRouter from 'vue-router';
import { queryAgreementReviewShow } from '@/api/rights/shop-mall';
import {
  // InstallMallCreditStatusEnum,
  // CreditMallFromEnum,
  ProductItemType,
} from '@/api/rights/shop-mall/types';
// import { RouterV2Enum } from '@/router/router-names';
import { ubtSendError } from '@/shared/utils/ubt';

/**
 * 处理分期商城流程请求
 * @param options 配置选项
 * @param options.isEasyBike 是否在端内
 * @param options.commodityIdList 分发到的自营、轻资产渠道id列表
 * @param options.router Vue Router 实例
 * @param options.from 来源标识，默认为 FINANCE_SCREENING_AGREEMENT
 * @returns Promise<boolean | undefined> 返回 showResult 或 false，如果已跳转则返回 undefined
 */
export async function handleFqMallReviewFlow(options: {
  isEasyBike: boolean;
  commodityIdList: (string | number)[];
  router: VueRouter;
  from?: string;
}): Promise<{
  showResult: boolean;
  productList?: ProductItemType[];
} | undefined> {
  const {
    isEasyBike,
    commodityIdList,
    // router,
    // from,
  } = options;

  // 如果在端内 并且 没有分发到的自营、轻资产渠道id
  if (isEasyBike && !commodityIdList.length) {
    try {
      const creditfqmallSummary = await queryAgreementReviewShow();
      // 字段含义：授信单号、该id状态（枚举）、是否准入
      const {
        // creditTaskId,
        // creditFrontStatus,
        showResult = false,
        // applyAmount,
        // jumpUrl,
        showProductList,
      } = creditfqmallSummary || {};

      if (showResult === false) {
        return { showResult: false };
      }

      // if (creditTaskId) {
      //   // 存在订单id 判断状态
      //   if (creditFrontStatus === InstallMallCreditStatusEnum.CREDIT_SUCCESS) {
      //     // 状态为成功（枚举值1），跳转到分期商城授信成功结果页
      //     router.replace({
      //       path: RouterV2Enum.fqMallPreApplySuccess,
      //       query: {
      //         creditTaskId,
      //         applyAmount,
      //         jumpUrl,
      //         from: from || CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
      //         source: 'double_enter',
      //       } as Dictionary<string>,
      //     });
      //     return undefined;
      //   }
      //   if (creditFrontStatus === InstallMallCreditStatusEnum.CREDIT_PROCESSING) {
      //     // 状态为授信中（枚举值2），跳转到等待页面（轮询授信结果）
      //     router.replace({
      //       path: RouterV2Enum.unitWaitingPage,
      //       query: {
      //         creditTaskId,
      //         from: from || CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
      //         source: 'double_enter',
      //       },
      //     });
      //     return undefined;
      //   }
      // }

      return { showResult, productList: showProductList } || { showResult: false };
    } catch (err) {
      ubtSendError('getFqMallPeApply error');
      return { showResult: false };
    }
  }

  return { showResult: false };
}
